/* MotoEbikes Workshop - shared selection bus.
   Lets the service selector, package cards and service cards pass choices
   into the multi-step request form without a page refresh. Loaded (deduped)
   by every workshop section that needs it. Vanilla JS, no dependencies. */
(function () {
  if (window.MEBWorkshopBus) return;

  var listeners = new Set();
  var state = new Map(); // value -> { value, label, type }
  var presetListeners = new Set();
  var presets = {}; // key -> value, for preselecting form fields (e.g. ownership, transport)

  function emit() {
    var arr = Array.prototype.slice.call(state.values ? Array.from(state.values()) : []);
    listeners.forEach(function (fn) {
      try { fn(arr); } catch (e) {}
    });
    try {
      document.dispatchEvent(new CustomEvent('meb-workshop:change', { detail: { items: arr } }));
    } catch (e) {}
  }

  function track(name, detail) {
    if (!name) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, detail || {}));
    } catch (e) {}
  }

  window.MEBWorkshopBus = {
    add: function (item) {
      if (!item || !item.value) return;
      state.set(item.value, item);
      track(item.trackEvent || 'workshop_service_added', { workshop_value: item.value });
      emit();
    },
    remove: function (value) { state.delete(value); emit(); },
    toggle: function (item) {
      if (!item || !item.value) return;
      if (state.has(item.value)) { state.delete(item.value); }
      else { state.set(item.value, item); track(item.trackEvent || 'workshop_service_added', { workshop_value: item.value }); }
      emit();
    },
    has: function (v) { return state.has(v); },
    all: function () { return Array.from(state.values()); },
    /* fn is called immediately with current state and on every change. Returns an unsubscribe. */
    on: function (fn) {
      listeners.add(fn);
      try { fn(Array.from(state.values())); } catch (e) {}
      return function () { listeners.delete(fn); };
    },
    track: track,
    /* Preselect a form field from elsewhere on the page (e.g. purchased-elsewhere, collection). */
    preset: function (key, value) {
      if (!key) return;
      presets[key] = value;
      presetListeners.forEach(function (fn) { try { fn(key, value); } catch (e) {} });
    },
    presets: function () { return presets; },
    onPreset: function (fn) {
      presetListeners.add(fn);
      Object.keys(presets).forEach(function (k) { try { fn(k, presets[k]); } catch (e) {} });
      return function () { presetListeners.delete(fn); };
    },
    /* Reliable in-page scroll that respects reduced-motion. */
    scrollTo: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = el.getBoundingClientRect().top + window.pageYOffset - 12;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    }
  };
})();